import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetContainerQrRedirectionCampaignsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetContainerQrRedirectionCampaignsQuery = { __typename?: 'Query', containerQrRedirectionCampaigns?: Array<{ __typename?: 'ContainerQrRedirectionCampaign', id: number, container_type_id: number, redirect_url: string, start_date: string, end_date: string, visit_count: number, comment?: string | null, forward_container_short_id?: boolean | null } | null> | null };


export const GetContainerQrRedirectionCampaignsDocument = gql`
    query getContainerQrRedirectionCampaigns {
  containerQrRedirectionCampaigns {
    id
    container_type_id
    redirect_url
    start_date
    end_date
    visit_count
    comment
    forward_container_short_id
  }
}
    `;

/**
 * __useGetContainerQrRedirectionCampaignsQuery__
 *
 * To run a query within a React component, call `useGetContainerQrRedirectionCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContainerQrRedirectionCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContainerQrRedirectionCampaignsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContainerQrRedirectionCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<GetContainerQrRedirectionCampaignsQuery, GetContainerQrRedirectionCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContainerQrRedirectionCampaignsQuery, GetContainerQrRedirectionCampaignsQueryVariables>(GetContainerQrRedirectionCampaignsDocument, options);
      }
export function useGetContainerQrRedirectionCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContainerQrRedirectionCampaignsQuery, GetContainerQrRedirectionCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContainerQrRedirectionCampaignsQuery, GetContainerQrRedirectionCampaignsQueryVariables>(GetContainerQrRedirectionCampaignsDocument, options);
        }
export type GetContainerQrRedirectionCampaignsQueryHookResult = ReturnType<typeof useGetContainerQrRedirectionCampaignsQuery>;
export type GetContainerQrRedirectionCampaignsLazyQueryHookResult = ReturnType<typeof useGetContainerQrRedirectionCampaignsLazyQuery>;
export type GetContainerQrRedirectionCampaignsQueryResult = Apollo.QueryResult<GetContainerQrRedirectionCampaignsQuery, GetContainerQrRedirectionCampaignsQueryVariables>;